import { useContext } from 'react';

import AddTeamModalContext from '@atom/components/common/workOrderDetail/addTeamModal/AddTeamModalContext';
import { Icon } from '@atom/mui';

import GroupsTreeRow from './GroupsTreeRow';

import classes from './groupsTab.module.css';

const GroupsTab = () => {
  const { userGroupTree, expanded } = useContext(AddTeamModalContext);

  const isExpanded = expanded.has(userGroupTree.id);
  const arrowDirection = isExpanded ? 'arrow_drop_down' : 'arrow_right';

  return (
    <>
      <div className={classes.row}>
        <div className={classes.rowContent}>
          <div className={classes.leftContent}>
            <Icon>{arrowDirection}</Icon>
            <div className={classes.nameContainer}>
              <div className={classes.title}>{userGroupTree.name}</div>
            </div>
          </div>
        </div>
      </div>
      {isExpanded &&
        userGroupTree.userGroups.map(group => (
          <GroupsTreeRow key={group.id} userGroup={group} indentation={0} />
        ))}
    </>
  );
};

export default GroupsTab;
